// extracted by mini-css-extract-plugin
export default {"examItem":"select-exam_examItem__v8a8b","is_active":"select-exam_is_active__ClS8Y","examItemWrap":"select-exam_examItemWrap__qUsip"};